import React from 'react';
import ReactPaginate from 'react-paginate';

const Pagination = ({ page, handlePageClick, pageCount }) => {
  return (
    <div id="react-paginate">
    <ReactPaginate
      forcePage={page - 1}
      breakLabel="..."
      nextLabel=">"
      onPageChange={handlePageClick}
      pageRangeDisplayed={5}
      pageCount={pageCount}
      previousLabel="<"
      renderOnZeroPageCount={null}
      className="relative z-0"
      previousClassName="relative inline-flex items-center px-3 py-1 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150 pagination-hover"
      nextClassName="relative inline-flex items-center px-3 py-1 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150 pagination-hover"
      pageLinkClassName="relative inline-flex items-center px-3 py-1 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150 pagination-hover"
      activeClassName="active-page"
    />
    </div>
  );
}

export default Pagination;